<div class="progress-bar">
  <div class="progress-bar_scale" [style.width.%]="execQtyWithMultiCurrency?.progressPercent" [class.-full]="execQtyWithMultiCurrency?.isFull"></div>
  @if (execQtyWithMultiCurrency) {
    <label ngPreserveWhitespaces class="progress-bar_label">
      <span>{{'components.widgets.order-details-widget.progress_bar_label' | l10n}}: </span>
      <span class="progress-bar_value">{{execQtyWithMultiCurrency.leftSideValue.value}}</span> <span class="progress-bar_currency">{{execQtyWithMultiCurrency.leftSideValue.currencySymbol}}</span>
      /
      <span class="progress-bar_value">{{execQtyWithMultiCurrency.rightSideValue.value}}</span> <span class="progress-bar_currency">{{execQtyWithMultiCurrency.rightSideValue.currencySymbol}}</span>
    </label>
  }
</div>
